import React from 'react';
import { Paragraph, SubTitle } from 'common-components/typography';
import { Col, Row } from 'antd';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';
import _ from 'lodash';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker';
import TimeInput from 'common-components/time-input/TimeInput';

interface AssignWorkerStep13Props {
  workerTimesheetStartTime: Date;
  workerTimesheetEndTime: Date;
  isLoading: boolean;
  onChangeActivityDate: (date: Date) => void;
  onChangeActivityStartTime: (time: Date) => void;
  onChangeActivityEndTime: (time: Date) => void;
  onClose: () => void;
  onSubmitAssign: (a: string) => Promise<void>;
}

export const AssignWorkerStep13 = ({
  workerTimesheetStartTime,
  workerTimesheetEndTime,
  isLoading,
  onChangeActivityDate,
  onChangeActivityStartTime,
  onChangeActivityEndTime,
  onClose,
  onSubmitAssign,
}: AssignWorkerStep13Props) => {
  return (
    <>
      <div className='mt-medium'>
        <Paragraph>
          In order to add this activity record to the team members timesheet you must indicate a start and finish time
          for the activity.
        </Paragraph>
      </div>
      <div className='mt-medium'>
        <SubTitle>ACTIVITY DATE</SubTitle>
        <DatePicker
          onChange={onChangeActivityDate}
          selected={moment(workerTimesheetStartTime).toDate()}
          className='gh-datepicker gh-datepicker-flat rounded'
          calendarClassName='gh-datepicker-calendar'
          dateFormat='dd/MM/yyyy'
          placeholderText={'Select a date'}
        />
      </div>
      <div className='mt-medium'>
        <Row type='flex' align='middle' className='mt-medium' gutter={24}>
          <Col span={9}>
            <SubTitle>START TIME </SubTitle>
            <TimeInput size='large' value={moment(workerTimesheetStartTime)} onChange={onChangeActivityStartTime} />
          </Col>
          <Col span={9}>
            <SubTitle>END TIME</SubTitle>
            <TimeInput size='large' value={moment(workerTimesheetEndTime)} onChange={onChangeActivityEndTime} />
          </Col>
        </Row>
      </div>
      <div className='mt-x3-large'>
        <Row type={'flex'} justify={'end'}>
          <SecondaryButton className='mr-medium' size='large' onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton size='large' loading={isLoading} onClick={async () => await onSubmitAssign('CHECKED_OUT')}>
            Add to timesheet
          </PrimaryButton>
        </Row>
      </div>
    </>
  );
};
